import React from 'react'
import { number } from 'prop-types'

import Progress from './CircularProgress.style'

function CircularProgress({ width }) {
  return <Progress style={{ width, height: 'auto' }} />
}

CircularProgress.propTypes = {
  width: number,
}

CircularProgress.defaultProps = {
  width: 35,
}

export default CircularProgress
